var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 76,
    viewBox: "0 0 236 76",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.8166 76H94.4281V0H65.8166V29.9301C60.9638 30.9516 54.6955 31.4624 49.0339 31.4624C35.9919 31.4624 28.7126 29.4194 28.7126 17.8763V0H0V21.5538C0 44.5376 14.4574 51.6882 42.0579 51.6882C52.8757 51.6882 60.4583 50.6667 65.8166 49.6452V76Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.09 58.7366L201.508 0H172.29L152.272 32.9946L130.131 0H96.8688L133.872 50.6667C134.782 51.8925 135.186 52.8118 135.186 53.8333V53.9355C135.186 54.957 134.579 55.672 132.557 55.672H119.313V76H134.377C151.059 76 154.496 71.8118 163.09 58.7366Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200.716 0L209.916 51.4839H226.699L236 0H200.716ZM232.664 56.0806H204.052V76H232.664V56.0806Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c0ca9f1.svg";
export { ForwardRef as ReactComponent };